module.exports = __webpack_public_path__ + "img/Tanning_1200x800.e6efd63a.png";